import { getApiClient, buildParams } from './client'

const JSON_HEADERS = {
  Accept: 'application/vnd.api+json',
  'Content-Type': 'application/vnd.api+json',
}

export function getAllServices(organizationId) {
  return getApiClient().get('/services', {
    headers: JSON_HEADERS,
    params: buildParams(organizationId),
  })
}

export function refreshService(organizationId, serviceId) {
  return getApiClient().get(`/services/${serviceId}`, {
    headers: JSON_HEADERS,
    params: buildParams(organizationId),
  })
}

export function subscribe(organizationId, data) {
  return getApiClient().post('/subscribe', data, {
    headers: JSON_HEADERS,
    params: buildParams(organizationId),
  })
}

export function toggleServiceActivation(organizationId, data) {
  return getApiClient().post('/toggle-service-activation', data, {
    headers: JSON_HEADERS,
    params: buildParams(organizationId),
  })
}

export function updateConfigs(organizationId, data) {
  return getApiClient().post('/update-configs', data, {
    headers: JSON_HEADERS,
    params: buildParams(organizationId),
  })
}

export function syncBatch(organizationId, serviceType, createdAfter) {
  return getApiClient().post(
    '/batch',
    { created_after: createdAfter, service_type: serviceType },
    { headers: JSON_HEADERS, params: buildParams(organizationId) },
  )
}

export function getBatch(organizationId, batchId) {
  return getApiClient().get(`/batch/${batchId}`, {
    headers: JSON_HEADERS,
    params: buildParams(organizationId),
  })
}

// --- Shipments ---

export function getAllShipments(params) {
  return getApiClient().get('/shipments', { params, headers: JSON_HEADERS })
}

export function getShipments(shippableType, shippableId) {
  return getApiClient().get(`/shipments/${shippableType}/${shippableId}`, {
    headers: JSON_HEADERS,
  })
}

export function getShipment(shipmentId, serviceId) {
  return getApiClient().get(`/shipments/show/${shipmentId}/${serviceId}`, {
    headers: JSON_HEADERS,
  })
}

export function estimateShipment(shippableType, shippableId, data) {
  return getApiClient().post(
    `/shipments/${shippableType}/${shippableId}/estimate`,
    data,
    { headers: JSON_HEADERS },
  )
}

export function editEstimation(shipmentId, data) {
  return getApiClient().post(`/shipments/${shipmentId}/edit-estimation`, data, {
    headers: JSON_HEADERS,
  })
}

export function destroyEstimation(shipmentId) {
  return getApiClient().delete(`/shipments/${shipmentId}`, {
    headers: JSON_HEADERS,
  })
}

export function createShipment(shipmentId, serviceId) {
  return getApiClient().post(
    `/shipments/${shipmentId}/create`,
    { service_id: serviceId },
    { headers: JSON_HEADERS },
  )
}

export function createPickup(shipmentId, pickupDetails) {
  return getApiClient().post(`/shipments/${shipmentId}/pickup`, pickupDetails, {
    headers: JSON_HEADERS,
  })
}

export function cancelShipment(shipmentId) {
  return getApiClient().post(`/shipments/${shipmentId}/cancel`, {}, {
    headers: JSON_HEADERS,
  })
}

export function cancelPickup(shipmentId) {
  return getApiClient().post(`/shipments/${shipmentId}/cancel-pickup`, {}, {
    headers: JSON_HEADERS,
  })
}

export function printShipmentLabel(shipmentId, labelType) {
  return getApiClient().post(
    `/shipments/${shipmentId}/print-label`,
    { label_type: labelType },
    { headers: JSON_HEADERS },
  )
}

export function trackShipment(shipmentId) {
  return getApiClient().get(`/shipments/${shipmentId}/track`, {
    headers: JSON_HEADERS,
  })
}

// --- GHL (GoHighLevel) ---

export function importGHLContacts(organizationId) {
  return getApiClient().post(
    '/ghl/import-contacts',
    {},
    { headers: JSON_HEADERS, params: buildParams(organizationId) },
  )
}

export function getGHLImportStatus(organizationId) {
  return getApiClient().get('/ghl/import-status', {
    headers: JSON_HEADERS,
    params: buildParams(organizationId),
  })
}
